function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import HeaderNavigation from "./header-navigation";
import { WDHComponent } from "../../../../wdh-foundation/wdh";
import HeaderActionLinks from "./header-action-links";
var HEADER_IS_OPEN_CSS_CLASS = "is-open";
var SEARCH_COMPONENT_CLASS = '.search-field-spot';
var HCPPortalHeader = /*#__PURE__*/function (_WDHComponent) {
  /**
   *
   * @param headerCssClassName
   * @param contentCssClassName
   * @param footerCssClassName
   * @augments WDHComponent
   * @inheritDoc
   */
  function HCPPortalHeader(headerCssClassName, contentCssClassName, footerCssClassName) {
    var _this;
    _classCallCheck(this, HCPPortalHeader);
    _this = _callSuper(this, HCPPortalHeader, [headerCssClassName]);
    _this.contentCssClassName = contentCssClassName;
    _this.footerCssClassName = footerCssClassName;
    _this.isOpen = false;
    _this.navigation = new HeaderNavigation('#header .navigation');
    _this.actionLinks = new HeaderActionLinks('#header .section-two');
    return _this;
  }
  _inherits(HCPPortalHeader, _WDHComponent);
  return _createClass(HCPPortalHeader, [{
    key: "onNavExpanderChanged",
    value: function onNavExpanderChanged(isActive) {
      this.setNavigationVisibility(isActive);
      this.setHeaderOpenStatus(isActive);
      this.setHeaderMinimumHeight(isActive);
      this.setRelevantScrollPosition(isActive);
    }
  }, {
    key: "onStickyNavigationChanged",
    value: function onStickyNavigationChanged(isSticky) {
      var mainHeaderContainer = this.getMainHeaderContainer();
      if (mainHeaderContainer) {
        if (isSticky) {
          mainHeaderContainer.classList.add('is-sticky');
        } else {
          mainHeaderContainer.classList.remove('is-sticky');
        }
      }
    }
  }, {
    key: "getMainHeaderContainer",
    value: function getMainHeaderContainer() {
      return document.querySelector(this.getClassName());
    }
  }, {
    key: "setNavigationVisibility",
    value: function setNavigationVisibility(isVisible) {
      this.navigation.isVisible = isVisible;
    }
  }, {
    key: "setHeaderOpenStatus",
    value: function setHeaderOpenStatus(isOpen) {
      this.isOpen = isOpen;
      if (isOpen) {
        this.headerElement.classList.add(HEADER_IS_OPEN_CSS_CLASS);
      } else {
        this.headerElement.classList.remove(HEADER_IS_OPEN_CSS_CLASS);
      }
    }
  }, {
    key: "setHeaderMinimumHeight",
    value: function setHeaderMinimumHeight(isOpen) {
      this.headerElement.style.minHeight = isOpen ? "".concat(window.innerHeight, "px") : "0";
    }
  }, {
    key: "setRelevantScrollPosition",
    value: function setRelevantScrollPosition(isOpen) {
      if (isOpen) {
        window.scrollTo(0, 0);
      } else {
        window.scrollTo(0, this.scrollValue);
      }
    }
  }, {
    key: "init",
    value: function init(component) {
      this.headerElement = component;
      this.contentElement = document.querySelector(this.contentCssClassName);
      this.footerElement = document.querySelector(this.footerCssClassName);
      this.navigation.run();
      this.actionLinks.searchElement = this.getSearchElement();
      this.actionLinks.run();
      this.setDropdown();
      this.setShapeGradientForLogo();
    }
  }, {
    key: "setShapeGradientForLogo",
    value: function setShapeGradientForLogo() {
      var shapeGradient = document.createElement('div');
      var container = this.headerElement.querySelector('.section-two .image.component .component-content a');
      shapeGradient.innerHTML = '<p>Home</p>';
      shapeGradient.classList.add('shapegradient');
      if (typeof container != 'undefined' && container != null) {
        container.appendChild(shapeGradient);
      }
    }
  }, {
    key: "setDropdown",
    value: function setDropdown() {
      var box = document.getElementById('dropdownBox');
      var btnUser = document.getElementById('btnUser');
      if (box && btnUser) {
        btnUser.addEventListener('click', function () {
          box.classList.toggle('remotecare-user-panel-box-active');
        });
      }
    }
  }, {
    key: "getSearchElement",
    value: function getSearchElement() {
      return document.querySelector(SEARCH_COMPONENT_CLASS);
    }
  }, {
    key: "addNonActiveSectionsToActionMenu",
    value: function addNonActiveSectionsToActionMenu() {
      var _this2 = this;
      if (!this.nonActiveSections) {
        this.nonActiveSections = this.navigation.getNonActiveSections();
        if (this.nonActiveSections) {
          this.nonActiveSections.reverse();
        }
      }
      if (this.nonActiveSections) {
        this.nonActiveSections.forEach(function (section) {
          _this2.actionLinks.prependElement(section);
        });
      }
    }
  }, {
    key: "addHCLButtonToActionMenu",
    value: function addHCLButtonToActionMenu() {
      var hclActionButton = this.hclLink.getHCLActionButton();
      if (hclActionButton) {
        this.actionLinks.prependElement(this.hclLink.getHCLActionButton());
      }
    }
  }, {
    key: "scroll",
    value: function scroll(component, scrollTop) {
      if (!this.isOpen) {
        this.saveScrollPosition(scrollTop);
      }
      if (scrollTop > 50) {
        this.onStickyNavigationChanged(true);
      } else {
        this.onStickyNavigationChanged(false);
      }
    }
  }, {
    key: "resize",
    value: function resize(component) {
      this.headerHeight = this.getHeaderHeight();
      this.footerHeight = this.getFooterHeight();
      this.setContentPadding(this.headerHeight, this.footerHeight);
      if (document.body.clientWidth < 992) {
        this.setNavigationMobileState(true);
        this.setHeaderOpenStatus(true);
      } else {
        this.setNavigationMobileState(false);
        this.setHeaderMinimumHeight(false);
      }
    }
  }, {
    key: "setNavigationMobileState",
    value: function setNavigationMobileState(isMobile) {
      this.navigation.isMobile = isMobile;
    }
  }, {
    key: "setContentPadding",
    value: function setContentPadding(top, bottom) {
      this.contentElement.style.padding = "".concat(top, "px 0 ").concat(bottom, "px 0");
    }
  }, {
    key: "getHeaderHeight",
    value: function getHeaderHeight() {
      return this.headerElement.clientHeight - this.headerElement.querySelector('.section-three').clientHeight - 1;
    }
  }, {
    key: "getFooterHeight",
    value: function getFooterHeight() {
      return this.footerElement.clientHeight;
    }
  }, {
    key: "saveScrollPosition",
    value: function saveScrollPosition(scrollTop) {
      this.scrollValue = scrollTop;
    }
  }]);
}(WDHComponent);
var header = new HCPPortalHeader('#header', '#content', '#footer');
header.run();